module.exports = require("date-fns/sub_days");


//////////////////
// WEBPACK FOOTER
// external "date-fns/sub_days"
// module id = 39
// module chunks = 0